/* eslint-disable camelcase */
import { isCountryPeruOrColombia } from '@constants/regions';

export const bankAccountDTO = (bankAccountData) => {
  const bankAccount = {
    account_data: bankAccountData.account_data,
    bank_data: bankAccountData.bank_data,
    owner_data: bankAccountData.owner_data,
  };

  if (isCountryPeruOrColombia) {
    // por una diferencia de responses entre los bff hay que eliminar el campo "owner_data.account_number"
    delete bankAccount.owner_data.account_number;
  } else {
    // por una diferencia de responses entre los bff hay que eliminar el campo "account_data.account_number"
    delete bankAccount.account_data.account_number;
  }

  return bankAccount;
};

export const extractCciFromBankAccount = (bankAccount) => {
  if (!bankAccount) return '';
  const {
    account_data: { product_code, currency_code, account_number_CCI },
    bank_data: { finantial_institution_id, finantial_institution_office, cci_verification_code },
  } = bankAccount;
  return `${finantial_institution_id}${finantial_institution_office}${product_code}${currency_code}${account_number_CCI}${cci_verification_code}`;
};
